import { useAuthContext } from './AuthContext';

export const LoginAuthenticated = ({ children, toLogin }) => {
  const { isUserAuthenticated } = useAuthContext();

  return isUserAuthenticated ? children : toLogin;
};
